import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-agrinome",
  "use": "icon-agrinome-usage",
  "viewBox": "0 0 59.78 80.54",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 59.78 80.54\" id=\"icon-agrinome\"><defs><style>#icon-agrinome .cls-1{fill:#030303;}#icon-agrinome .cls-2{fill:#77b7e4;}</style></defs><title>agrinome</title><path class=\"cls-1\" d=\"M461.61,392.5c0-9,.1-18-.06-27-.05-2.89.52-4,3.79-4.08,12.58-.16,12.57-.3,12.57,12.19,0,15.17-.08,30.33.07,45.5,0,3-.56,4.31-3.79,3.92-4.1-.5-9.58,1.77-12-.93-2-2.27-.58-7.62-.61-11.6C461.59,404.5,461.61,398.5,461.61,392.5Z\" transform=\"translate(-440.27 -342.91)\" /><path class=\"cls-1\" d=\"M440.31,370.48c0-8,.08-16,0-23.93,0-2.51.61-3.4,3.31-3.5,13.17-.48,13.16-.57,13.16,12.56,0,13-.1,25.93.08,38.89,0,3.19-.7,4.27-4.09,4.27-12.42,0-12.42.17-12.42-12.33Z\" transform=\"translate(-440.27 -342.91)\" /><path class=\"cls-2\" d=\"M500,371.16c0,8-.1,16,.05,23.95.05,2.8-.86,3.68-3.69,3.79-12.49.46-12.49.55-12.48-11.95,0-13.14.1-26.28-.08-39.42,0-3.48,1-4.52,4.51-4.53C500,343,500,342.86,500,354.7Z\" transform=\"translate(-440.27 -342.91)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/agrinome.svg
// module id = LDn3
// module chunks = 102